
import React from 'react'
import Card from '../../components/card'
import { AuthContext } from '../../main/authProvider'
import { withRouter } from 'react-router-dom'
import DateIntervalCalendar from '../../components/calendar/dateIntervalCalendar'
import ConstantsUtil from '../../context/constantsUtil'
import GeneralServices from '../../app/service/generalServices'
import { Button } from 'primereact/button'
import LancamentoDataValorTable from '../../components/estoque/lancamentoDataValorTable'
import AuthService from '../../app/service/authService'
import * as popUp from '../../components/toastr'
import HandleErrorService from '../../app/service/handleErrorService'
import { Dialog } from 'primereact/dialog'
import CustomCalendar from '../../components/calendar/customCalendar'
import { InputNumber } from 'primereact/inputnumber'
import DialogFooter from '../../components/dialogFooter'
import EstoqueCMVService from '../../app/service/estoque/estoqueCMVService'
import ReceitaServicoService from '../../app/service/receitaServicoService'


class LancamentoDataValor extends React.Component {

    constructor(){
        super()
        this.generalServices = new GeneralServices()
        this.estoqueCMVService = new EstoqueCMVService()
        this.receitaServicoService = new ReceitaServicoService()
    }
    
    state = {
        
        selectedDateFilterType: '',
        missingFilterType: false,
        missingAnyDate: false,
        initialDate: '',
        initialDateView: '',
        finalDate: '',
        finalDateView: '',
        
        habilitaBusca: true,
        loading: false,

        lancamentoToCreateOrEdit: null,
        displayDialog: false,

        inputDateErrorClass: '',
        errorDateMessage: '',

        inputValorErrorClass: '',
        errorValueMessage: '',        

    }

    componentDidMount(){
        // this.autoSearch()
    }

    // autoSearch = async () => {
    //     await this.generalServices.sleep(100)
    //     this.search()
    // }

    header = () => {

        switch(window.location.pathname){
            case ConstantsUtil.valorDeEstoquePathname:
                return "Valor de Estoque"
                
            case ConstantsUtil.receitaServicoPathname:
                return "Receita de Serviço"
        }

    }

    getModo = () => {
        switch(window.location.pathname){
            case ConstantsUtil.valorDeEstoquePathname:
                return ConstantsUtil.modoValorDeEstoque
                
            case ConstantsUtil.receitaServicoPathname:
                return ConstantsUtil.modoReceitaDeVendas
        }        
    }

    handleDateFilterChange = (selectedDateFilterType) => {
        this.setState({selectedDateFilterType})
    }

    handleDateChange = async (initialDate, finalDate) => {
        await this.setState({initialDate})
        // console.log("handleDateChange initial: ", this.state.initialDate)
        
        await this.setState({initialDateView: GeneralServices.convertBrStringToJsDate(initialDate)})
        // console.log("handleDateChange initialView: ", this.state.initialDateView)

        await this.setState({finalDate})
        await this.setState({finalDateView: GeneralServices.convertBrStringToJsDate(finalDate)})

    }

    getDataInicial = () => {
        if(this.props.dataInicial){
            //Recebeu dhEmi da NF
            let dataInicial = GeneralServices.convertBrStringToJsDate(this.props.dataInicial)
            dataInicial.setDate(dataInicial.getDate() - 30)
            return dataInicial            
        }
        else{
            let dataInicial = new Date()
            dataInicial.setDate(dataInicial.getDate() - 30)
            return dataInicial;
        }

    }

    getDataFinal = () => {
        
        if(this.props.dataInicial){
            //Recebeu dhEmi da NF
            return GeneralServices.convertBrStringToJsDate(this.props.dataInicial)
        }

        else{
            return new Date()
        }
        

    }

    toggleButton = () => {
        this.setState({habilitaBusca: !this.state.habilitaBusca})
    }

    resetView = () => {

        this.setState({missingFilterType: false})
        this.setState({missingAnyDate: false})

        this.setState({inputEmpresasErrorClass: ''})
        this.setState({errorEmpresasErrorMessage: ''})

    }

    checkData = () => {

        var check = true

        if(!this.state.selectedDateFilterType){
            this.setState({missingFilterType: true})
            check=false
        }
        
        if(!this.state.initialDate || !this.state.finalDate){
            this.setState({missingAnyDate: true})
            check=false
        }

        return check
    }

    search = () => {

        this.resetView()

        if(this.checkData()){
            this.setState({habilitaBusca: false})
        }

    }

    research = async () => {
        await this.setState({habilitaBusca: true})
        this.search()
    }

    callCreate = () => {
        this.viewDialog({})
    }

    viewDialog = (lancamento) => {
        this.setState({
            lancamentoToCreateOrEdit: JSON.parse(JSON.stringify(lancamento)),
            displayDialog: true,
        })
    }

    hideDialog = () => {
        this.setState({displayDialog: false})
    }

    handleDataLancamentoChange = (event) => {
        let lancamentoToCreateOrEdit = this.state.lancamentoToCreateOrEdit
        lancamentoToCreateOrEdit.dataLancamento = event.value ? GeneralServices.convertJSDateToBrDate(event.value) : null
        this.setState({lancamentoToCreateOrEdit})
    }

    handleValorChange = (event) => {
        let lancamentoToCreateOrEdit = this.state.lancamentoToCreateOrEdit
        lancamentoToCreateOrEdit.valor = event.value
        this.setState({lancamentoToCreateOrEdit})
    }

    resetView = () => {
        this.setState({
            inputDateErrorClass: '',
            errorDateMessage: '',
            inputValorErrorClass: '',
            errorValueMessage: '',
        })
    }

    checkDataForCreateOrEdit = () => {

        var check = true

        if(!this.state.lancamentoToCreateOrEdit.dataLancamento){
            this.setState({
                inputDateErrorClass: ConstantsUtil.primereactInputErrorClass,
                errorDateMessage: 'Preencha a data',
            })
            check = false
        }

        if(!this.state.lancamentoToCreateOrEdit.valor){
            this.setState({
                inputValorErrorClass: ConstantsUtil.primereactInputErrorClass,
                errorValueMessage: 'Preencha o valor',
            })
            check = false
        }

        return check

    }

    callSave = () => {
        this.resetView()
        if(this.checkDataForCreateOrEdit()){
            // console.log('this.state.lancamentoToCreateOrEdit: ', this.state.lancamentoToCreateOrEdit)
            if(this.state.lancamentoToCreateOrEdit.id){
                this.edit()
            }
            else{
                this.create()
            }
        }
    }

    create = () => {

        AuthService.startBlockUi()

        this.handleCreate()
        .then(response => {
            popUp.successPopUp("Lançamento criado com sucesso!")
            this.hideDialog()
            if(!this.state.habilitaBusca){
                this.research()
            }
        })
        .catch(error => HandleErrorService.handleError(error))
        .finally(() => {
            AuthService.stopBlockUi()
        })
    }

    handleCreate = () => {

        switch(window.location.pathname) {
            case ConstantsUtil.valorDeEstoquePathname:
                return this.estoqueCMVService.create(this.state.lancamentoToCreateOrEdit)
                
            case ConstantsUtil.receitaServicoPathname:
                return this.receitaServicoService.create(this.state.lancamentoToCreateOrEdit)
        }

    }

    edit = () => {

        AuthService.startBlockUi()

        this.handleEdit()
        .then(response => {
            popUp.successPopUp("Lançamento editado com sucesso!")
            this.research()
        })
        .catch(error => HandleErrorService.handleError(error))
        .finally(() => {
            this.hideDialog()
            AuthService.stopBlockUi()
        })
    }

    handleEdit = () => {
        switch(window.location.pathname) {
            case ConstantsUtil.valorDeEstoquePathname:
                return this.estoqueCMVService.edit(this.state.lancamentoToCreateOrEdit)
                
            case ConstantsUtil.receitaServicoPathname:
                return this.receitaServicoService.edit(this.state.lancamentoToCreateOrEdit)
        }        
    }

    render(){

        const renderButtons = () => {
            if(this.state.habilitaBusca){
                return (
                    <Button
                        label="Buscar"
                        icon="pi pi-search"
                        className='small-button'
                        onClick = {this.search}
                    />
                )
            }
            return (
                <>
                    <Button 
                        label="Voltar"
                        icon="pi pi-undo"
                        className="p-button-danger small-button"
                        onClick = {() => {
                            this.setState({filterNFTableState: {}})
                            this.toggleButton()
                        }}
                    />
                </>
            )            
        }

        const renderCreateButton = () => {
            return (
                <Button
                    label="Lançar"
                    icon="pi pi-plus"
                    className='small-button'
                    style={{marginLeft: '10px'}}
                    onClick = {this.callCreate}
                />
            )            
        }

        const renderDialog = () => {
            return (
                <Dialog
                    visible={this.state.displayDialog}
                    header={this.state.lancamentoToCreateOrEdit?.id ? "Editar" : "Lançar"}
                    modal = {true}
                    style={{ width: '350px' }}
                    footer={dialogFooter}
                    onHide={this.hideDialog}
                >
                    <div className="p-field">

                        <CustomCalendar
                            ref={this.dateInputRef}
                            id="dataLancamentoFechamentoCaixa"
                            htmlFor="icon"
                            label="Data do Lançamento"
                            inputDateErrorClass={this.state.inputDateErrorClass}
                            value={GeneralServices.convertBrStringToJsDate(this.state.lancamentoToCreateOrEdit?.dataLancamento)}
                            name="dataLancamento"
                            noHTMLFormat
                            onChange={this.handleDataLancamentoChange}
                            errorDateMessage={this.state.errorDateMessage}
                        />

                        <br />

                        <div className="row">
                            <div className="col-md-8">
                                <label htmlFor="valor" style={{ display: 'block' }}>Valor</label>
                                <InputNumber
                                    // ref={this.inputValorRef}
                                    inputStyle={{ width: '12rem' }}
                                    className={this.state.inputValorErrorClass}
                                    name="valor"
                                    inputId="valor"
                                    value={this.state.lancamentoToCreateOrEdit?.valor}
                                    onValueChange={this.handleValorChange}
                                    onKeyDown={this.handleKeyPress}
                                    mode="decimal" locale="pt-BR" minFractionDigits={2}
                                    // disabled={this.isProvisaoFromNFOuNFse()}
                                />
                                <div className="invalid-feedback">Preencha</div>                
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <small id="valorError" className="p-error">{this.state.errorValueMessage}</small>
                            </div>
                        </div>

                    </div>
                </Dialog>
            )            
        }

        const dialogFooter = (
            <DialogFooter save = {this.callSave} hideDialog = {this.hideDialog}/>
        )        

        const renderTable = () => {
            if(!this.state.habilitaBusca)
            return(
                <div className="row">
                <div className = "col-md-12">
                    <LancamentoDataValorTable
                        initialDate={this.state.initialDate}
                        finalDate={this.state.finalDate}
                        viewDialog={this.viewDialog}
                        modo={this.getModo()}
                    />

                </div>
                </div>
            )
        }

        return(
            <div className="bs-docs-section" >
                
                <Card title = {this.header()}>
                    <div className = "col-md-12">
                    <div className="row">

                        <DateIntervalCalendar
                            htmlFor="SelectDatePeriod"
                            // defaultValue={ConstantsUtil.calendarPersonalizadoFilterLabel}
                            handleFilterChange={this.handleDateFilterChange}
                            handleDateChange={this.handleDateChange}
                            missingFilterType={this.state.missingFilterType}
                            missingAnyDate={this.state.missingAnyDate}
                            disabled={!this.state.habilitaBusca}
                            preSetFilterType={ConstantsUtil.calendarMesCompletoFilterLabel}
                            // preSetDataInicial={this.getDataInicial()}
                            // preSetDataFinal={this.getDataFinal()}
                            enableChangeFilterType
                            disableAutoFocus
                        />
                    </div>

                    <div
                        style={{marginTop: '0.5rem', marginBottom: '0.5rem'}}
                    >
                        {renderButtons()}
                        {renderCreateButton()}
                    </div>

                    {renderTable()}

                    {renderDialog()}

                    </div>
                </Card>
                <div className="d-flex "/>
            </div>
        )
    }

}

LancamentoDataValor.contextType = AuthContext

export default withRouter(LancamentoDataValor)